import ErrorBoundary from "@/components/utils/ErrorBoundary"
import { clearReload } from "@/components/utils/helpers/Loading"
import CircularProgress from "@mui/material/CircularProgress"
import {
  type ComponentProps,
  type ComponentType,
  type LazyExoticComponent,
  type ReactNode,
  Suspense,
} from "react"

const GetLoadable =
  // biome-ignore lint/suspicious/noExplicitAny: Generic
  <T extends ComponentType<any>>(Component: LazyExoticComponent<T>, loading?: ReactNode) =>
    (rest: ComponentProps<T>) => {
      clearReload()

      return (
        <ErrorBoundary>
          <Suspense
            fallback={
              loading ?? (
                <div className="flex-center-center">
                  <CircularProgress />
                </div>
              )
            }
          >
            <Component {...rest} />
          </Suspense>
        </ErrorBoundary>
      )
    }

export default GetLoadable
